import * as loginActionTypes from "../constants/loginActionTypes";
import { buildAction, dispatch } from "./iframeHelpers";
import type { ClientError } from "./otpHelpers";
import type { RecaptchaError } from "./recaptcha";

/**
 * Message sent after initiating an OTP request for email/phone login
 */
export const otpTokenLoginStart = buildAction(
  loginActionTypes.OTP_TOKEN_LOGIN_START
);

/**
 * Message sent after starting a login
 */
export const loginStart = buildAction(loginActionTypes.LOGIN_START);

/**
 * Message sent after a successful login
 */
export const loginSuccess = buildAction(loginActionTypes.LOGIN_SUCCESS);

/**
 * Message sent after a failure in login
 */
export const loginFailure = buildAction(loginActionTypes.LOGIN_FAILURE);

export const dispatchLoginFailure = (data: ClientError | RecaptchaError) =>
  dispatch(buildAction(loginActionTypes.LOGIN_FAILURE)(data));
